import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import {
  decorationItems,
  DecorationItemID,
  DecorationThemeID,
  tiersItemsMap,
} from './decoration.ruleset';
import { DecorationTierID } from '../data/DecorationTiers.schema';
import {
  addDecorationItem,
  addDecorationItemTier,
  equipDecorationItem,
  unequipAllDecorationItems,
} from './decoration.modifiers';

export const decorationCheats = createActions({
  cheat_decorationEquipCollection: action(
    (state, args: { theme: DecorationThemeID }, api) => {
      const now = api.date.now();

      // Group items by (room, slot), picking one variant per slot.
      // Priority: color 'a' > 'na' > first available.
      const itemsByRoomSlot = new Map<
        string,
        (typeof decorationItems)[number]
      >();

      for (const item of decorationItems) {
        if (item.theme !== args.theme) continue;

        const key = `${item.room}_${item.slot}`;
        const existing = itemsByRoomSlot.get(key);

        if (!existing) {
          itemsByRoomSlot.set(key, item);
        } else if (item.color === 'a') {
          itemsByRoomSlot.set(key, item);
        } else if (item.color === 'na' && existing.color !== 'a') {
          itemsByRoomSlot.set(key, item);
        }
      }

      // Unequip all rooms first
      unequipAllDecorationItems(state, 'living');
      unequipAllDecorationItems(state, 'toilet');

      // Add and equip each item
      for (const item of itemsByRoomSlot.values()) {
        const tierIds = (
          Object.keys(tiersItemsMap[item.id] ?? {}) as DecorationTierID[]
        ).sort();
        if (tierIds.length === 0) continue;

        // Add to purchased with first tier if not already owned
        const isAlreadyPurchased = !!state.decoration.purchased[item.id];
        if (!isAlreadyPurchased) {
          addDecorationItem(state, item.id, tierIds[0], now);
        }

        // Add any missing tiers (including tier 0 when already owned)
        const startIndex = isAlreadyPurchased ? 0 : 1;
        for (let i = startIndex; i < tierIds.length; i++) {
          if (!state.decoration.purchased[item.id]?.tier[tierIds[i]]) {
            addDecorationItemTier(state, item.id, tierIds[i], now);
          }
        }

        equipDecorationItem(
          state,
          item.id as DecorationItemID,
          item.room,
          item.slot,
          tierIds[tierIds.length - 1],
        );
      }
    },
  ),

  cheat_decorationReset: action((state) => {
    state.decoration.purchased = {};
    state.decoration.selected = [];
  }),
});
